export const API_VERSION = 'v1.0'
const HOST_URL = `ksa.empirecinemas.com`
const LIVEBASEURL = `https://brij-web-api.empirecinemas.com`

let DEVBASEURL = `http://localhost:3800`
let IMG_URL = `https://brij-web-api.empirecinemas.com`

export const ImageS3URL = `https://images.brijimages.com/`
DEVBASEURL = `https://brij-web-api.empirecinemas.com`

export const IMG_BASEURL = IMG_URL

export const BASEURL_BRIJ =
  window.location.host === HOST_URL ? LIVEBASEURL : DEVBASEURL

export const Empire = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjdlN2IzZWFiLTJlOTEtNDkzOS05ZjBmLTdmMzQyODJmZTZjYSIsImlhdCI6MTY1OTk0MzkxM30.qpq-sdSPtmXu2vHdv4EYembuqM_VaFZdtuCmMI4jhGQ`

export const TOKEN = Empire

export const PublicKey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAoCEl5ixvb/RjLH709xNG
37ZNwacJsMImIvfmwP5cOCsTEWjNm/PeRSwrpQsK0GkEimngAZREcFNGbAVW71m/
lqCPy1/iJ+BPhzuGa6hzi8vDUA6ORvDvprEA+FobKUxS02uGMiIuBsIctGxJWLr3
PTbKUdYgzZPae593VBAOooaS1nFo2Msh3mDXvVyh6l2h0F8jhmoxqb0RFZY898/+
oWbhJUSJcPdH+kbn2rwoHjIGirKc5E/Xht/2R2xKKErys0kyByuXqhOvjel4mOcA
vTzXLsYbPoqFgQpvICQG0SRmWeZhcBt5DM7SoEuaJw2AJNtL/d41RmUfD9bwmcXq
MwIDAQAB
-----END PUBLIC KEY-----`;



// WEBPACK FOOTER //
// ./src/config/index.js